// Script específico para manejar variantes en el cart drawer
document.addEventListener('DOMContentLoaded', function() {
  console.log('🛒 Inicializando manejo de variantes en cart drawer...');
  
  // Función para inicializar variantes en el cart drawer
  function initializeCartDrawerVariants() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;
    
    // Observar cuando se abre el cart drawer
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
          const isOpen = cartDrawer.getAttribute('aria-hidden') === 'false';
          if (isOpen) {
            console.log('📦 Cart drawer abierto - inicializando variantes...');
            setTimeout(() => {
              // Forzar la reinicialización del selector de variantes
              const event = new CustomEvent('cartDrawerOpened');
              document.dispatchEvent(event);
            }, 300);
          }
        }
      });
    });
    
    observer.observe(cartDrawer, {
      attributes: true,
      attributeFilter: ['aria-hidden']
    });
  }
  
  // Escuchar el evento personalizado para reinicializar variantes
  document.addEventListener('cartDrawerOpened', function() {
    console.log('🔄 Reinicializando variantes después de abrir cart drawer...');
    
    // Buscar todos los selectores de variantes en el cart drawer
    const selectItems = document.querySelectorAll('cart-drawer .select-items');
    selectItems.forEach((selectItem) => {
      // Remover la marca de inicializado para forzar reinicialización
      delete selectItem.dataset.initialized;
    });
    
    // Disparar el evento para que el script principal reinicialice
    const event = new CustomEvent('searchComplete');
    document.dispatchEvent(event);
  });
  
  // Inicializar cuando el DOM esté listo
  initializeCartDrawerVariants();
}); 